import type {Event, EventHint} from '@sentry/types';

import {urlSanitizer} from '@/services/sanitizers';

export function sentryEventSanitizer<T extends Event>(event: T, _hint: EventHint) {
    if (event.request) {
        if (event.request.url) {
            event.request.url = urlSanitizer(event.request.url);
        }
        if (event.request.headers?.Referer) {
            event.request.headers.Referer = urlSanitizer(event.request.headers.Referer);
        }
    }
    event.breadcrumbs = event.breadcrumbs?.filter(breadcrumb => {
        const url = breadcrumb.data?.url as string;
        if (url) {
            return !url.includes('https://r.lr-in-prod.com/i');
        }
        return true;
    });
    event.breadcrumbs?.forEach(breadcrumb => {
        if (breadcrumb.data) {
            if (breadcrumb.data.url) {
                breadcrumb.data.url = urlSanitizer(breadcrumb.data.url);
            }
            if (breadcrumb.data.from) {
                breadcrumb.data.from = urlSanitizer(breadcrumb.data.from);
            }
            if (breadcrumb.data.to) {
                breadcrumb.data.to = urlSanitizer(breadcrumb.data.to);
            }
        }
    });
    event.transaction = event.transaction
        ? urlSanitizer(event.transaction)
        : event.transaction;
    return event;
}
